<template>
  <v-container fluid class="px-0">
    <v-file-input
      class="fileInput"
      ref="fileInput"
      :accept="fileType"
      :multiple="multiple"
      @change="addFiles"
    ></v-file-input>
    <v-card
      v-if="!loading && !showBylosList"
      ref="dragInput"
      @drop.prevent="onDrop($event)"
      @dragover.prevent="dragover = true"
      @dragenter.prevent="dragover = true"
      @dragleave.prevent="dragover = false"
      @click.prevent="clickUpload"
      :class="dragClass"
      :disabled="!canUpload"
    >
      <v-card-text>
        <v-row class="d-flex flex-column" dense align="center" justify="center">
          <v-icon
            :class="[dragover ? 'mt-2, mb-6' : 'mt-0 ']"
            color="primary"
            size="50"
          >
            mdi-cloud-upload
          </v-icon>
          {{ uploadText }}
        </v-row>
        <v-virtual-scroll
          v-if="isUpload"
          :items="uploadedFiles"
          item-height="60"
        >
          <template v-slot:default="{ item }">
            <v-list-item :key="item.name">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.name }}
                  <span class="ml-3 text--secondary">
                    {{ fileSize(item.size) }}</span
                  >
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-action v-if="!instant">
                <v-btn @click.stop="removeFile(item.name)" icon>
                  <v-icon> mdi-close-circle </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-virtual-scroll>
        <div>
          <v-progress-linear
            :value="progress"
            v-if="isUpload"
            color="light-blue"
            height="25"
            disabled
          >
            <strong>{{ progress }} %</strong>
          </v-progress-linear>
        </div>
      </v-card-text>
    </v-card>

    <v-data-table
      v-if="showBylosList"
      :headers="filteredHeaders"
      :items="bylosList"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :hide-default-header="true"
      :page.sync="page"
      :items-per-page="pageSize"
    >
      <template #[`item.actions`]="{ item }">
        <el-table-action :item="item" @deleteItem="deleteByla(item)" />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-delete
      title="Pašalinti rinkmeną"
      :text="modalDeleteText"
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import ModalDelete from '../../modals/ModalDelete'

export default {
  name: 'IgaliojimasUpload',
  components: { ModalDelete },
  props: {
    pazyma: Object,
    fileType: {
      type: String,
      default: '.pdf,.adoc,.asice',
    },
    multiple: { type: Boolean, default: false },
    instant: { type: Boolean, default: false },
    readonly: Boolean,
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      modalloading: true,
      loading: false,
      modalUpload: {
        byla: null,
      },
      dragover: false,
      progress: 0,
      uploadedFiles: [],
      uploadValidated: true,
      search: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      page: 1,
      showDelete: false,
      modalDeleteText: null,
      modalDeleteItem: null,
      bylos: [],
      maxDydis: 0,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Pavadinimas',
          align: 'start',
          value: 'byl_pavadinimas',
        },
        {
          text: 'Veiksmai',
          align: 'right',
          value: 'actions',
          width: 80,
          cellClass: 'actions',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    bylosList() {
      return this.bylos.map((item, index) => {
        item.eilnr = index + 1

        item.byl_url = `ntrpaslaugos/byla/${item.byl_id}/${item.byl_hash}/content`
        item.canDownload = true
        item.canDelete = !this.isReadonly
        return item
      })
    },
    hideFooter() {
      return this.bylosList.length <= 10
    },
    dragClass() {
      return (this.dragover ? 'blue lighten-1' : '') + 'mb-2'
    },
    isUpload() {
      return this.uploadedFiles.length > 0
    },
    uploadText() {
      return 'Paspauskite arba įtempkite rinkmeną'
    },
    canUpload() {
      return true
    },
    isByla() {
      return this.modalUpload.byl_id > 0 && this.modalUpload.byl_pavadinimas
    },
    isDeleted() {
      return (
        this.modalUpload.byl_id > 0 && this.modalUpload.byl_pavadinimas === null
      )
    },
    fileTypeList() {
      return this.fileType.replaceAll('.', '').split(',')
    },
    maxDydisByte() {
      return this.maxDydis * 1024 * 1024
    },
    pazymaId() {
      return this.pazyma?.paz_id
    },
    showBylosList() {
      return this.bylosList.length > 0
    },
    isReadonly() {
      return this.readonly
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.modalloading = true
      this.loading = true

      this.$axios
        .get(`ntrpaslaugos/pazyma/${this.pazymaId}/igaliojimai/byla`)
        .then(res => {
          this.bylos = res.data.bylos
          this.maxDydis = res.data.rinkmena_dydis
          this.$emit('loaded')
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clickUpload() {
      this.$refs.dragInput.$el.blur()
      this.$refs.fileInput.$refs.input.click()
    },
    addFiles(files) {
      this.dragover = false
      this.uploadedFiles = []
      let fileArray
      if (Array.isArray(files)) {
        fileArray = [...files]
      } else {
        fileArray = [files]
      }
      fileArray.forEach(element => this.addUploadedFiles(element))

      if (this.instant) {
        this.saveData()
      }
    },
    addUploadedFiles(element) {
      let tipas = element.name
        .toLowerCase()
        .split('.')
        .pop()
      if (!this.fileTypeList.includes(tipas)) {
        window._VMA.$emit('DATA_ERROR', 'Netinkamas rinkmenos formatas')
        return
      }
      if (element.size > this.maxDydisByte) {
        window._VMA.$emit(
          'DATA_ERROR',
          `Leistinas rinkmenos dydis: ${this.maxDydis} MB`
        )
        return
      }

      this.uploadedFiles.push(element)
      this.validateUpload()
    },
    fileSize(size) {
      if (size < 1024) {
        return size + ' B'
      } else if (size < 1024 * 1024) {
        return Math.round(size / 1024) + ' KB'
      } else if (size < 1024 * 1024 * 1024) {
        return Math.round(size / (1024 * 1024)) + ' MB'
      }
    },

    removeFile(fileName) {
      // Find the index of the
      const index = this.uploadedFiles.findIndex(file => file.name === fileName)

      // If file is in uploaded files remove it
      if (index > -1) this.uploadedFiles.splice(index, 1)
    },
    removeUploadedFile() {
      this.modalUpload.byl_pavadinimas = null
    },

    onDrop(e) {
      this.dragover = false

      // If there are already uploaded files remove them
      if (this.isUpload) this.uploadedFiles = []

      // If user has uploaded multiple files but the component is not multiple throw error
      if (!this.multiple && e.dataTransfer.files.length > 1) {
        window._VMA.$emit(
          'DATA_ERROR',
          'Vienu metu galima įkelti tik vieną doumentą'
        )
      }
      // Add each file to the array of uploaded files
      else {
        // e.dataTransfer.files.forEach(element => this.addUploadedFiles(element))
        const fileArray = [...e.dataTransfer.files]
        fileArray.forEach(element => this.addUploadedFiles(element))
      }

      if (this.instant) {
        this.saveData()
      }
    },
    validateUpload() {
      this.uploadValidated = this.isUpload
    },
    updateProgress(progress) {
      this.progress = progress
    },
    saveData() {
      this.validateUpload()
      this.$validator.validateAll().then(res => {
        if (!(res && this.uploadValidated)) {
          window._VMA.$emit('DOCUMENT_ERROR')
          return
        }

        this.loading = true
        this.$emit('isLoading')

        const byla = this.uploadedFiles[0]
        let formData = new FormData()

        formData.append('paz_id', this.pazymaId)
        formData.append('byla', byla)

        const config = {
          onUploadProgress: progressEvent => {
            this.progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )
          },
        }

        this.$axios
          .post(
            `ntrpaslaugos/pazyma/${this.pazymaId}/igaliojimai/byla`,
            formData,
            config
          )
          .then(res => {
            window._VMA.$emit('DATA_OK', res.data.message)
            this.bylos = res.data.bylos
            this.uploadedFiles = []
            this.$emit('loaded')
          })
          .catch(err => {
            window._VMA.$emit('DATA_ERROR', err.response.data.message)
            this.progress = 0
          })
          .finally(() => {
            this.loading = false
            this.$emit('updatePazyma')
          })
      })
    },
    deleteByla(item) {
      this.modalDeleteText = `Ar norite pašalinti rinkmeną <strong>${item.byl_pavadinimas}</strong>?`
      this.modalDeleteItem = { zin_id: item.zin_id, byl_id: item.byl_id }
      this.showDelete = true
    },
    confirmDelete(item) {
      if (!item.byl_id) {
        return
      }
      this.loading = true
      this.$emit('isLoading')

      this.$axios
        .delete(
          `ntrpaslaugos/pazyma/${this.pazymaId}/igaliojimai/byla/${item.byl_id}`
        )
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.bylos = res.data.bylos
          this.$emit('loaded')
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.$emit('updatePazyma')
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.fileInput {
  display: none;
}
.div-inline {
  display: inline-flex;
  line-height: 20px;
}
.div-tooltip {
  font-size: 14px;
}
.upload-label label {
  font-size: 1.09em;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.65);
}
.actions {
  width: 80px;
}
</style>
